import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FileText, Download } from 'lucide-react';
import './FieldMappings.css';

function FieldMappings() {
  const [mappings, setMappings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMappings();
  }, []);

  const loadMappings = async () => {
    try {
      const response = await axios.get('/api/mappings');
      setMappings(response.data || []);
    } catch (err) {
      console.error('Failed to load mappings:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async (mappingId) => {
    try {
      const response = await axios.get(`/api/mappings/${mappingId}`);
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/json;charset=utf-8,' +
        encodeURIComponent(JSON.stringify(response.data, null, 2)));
      element.setAttribute('download', `mapping-${mappingId}.json`);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    } catch (err) {
      console.error('Failed to export:', err);
      alert('Error exporting mapping');
    }
  };

  return (
    <div className="field-mappings">
      <div className="page-header">
        <div>
          <h1>Field Mappings</h1>
          <p>View and manage custom field mappings</p>
        </div>
      </div>

      {loading ? (
        <div className="loading-state">
          <FileText size={48} />
          <p>Loading mappings...</p>
        </div>
      ) : mappings.length === 0 ? (
        <div className="empty-state">
          <FileText size={48} />
          <p>No field mappings yet</p>
          <small>Create mappings in the Upload PDFs section to see them here</small>
        </div>
      ) : (
        <div className="mappings-list">
          {mappings.map(mapping => (
            <div key={mapping._id} className="mapping-card">
              <div className="mapping-header">
                <h3>Mapping #{mapping._id?.toString().slice(-6)}</h3>
                <span className={`status-badge ${mapping.status}`}>
                  {mapping.status}
                </span>
              </div>

              <div className="mapping-info">
                <div className="info-item">
                  <span className="label">Created</span>
                  <span className="value">
                    {new Date(mapping.mappingMetadata?.createdAt).toLocaleDateString()}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Fields</span>
                  <span className="value">{mapping.customFields?.length || 0}</span>
                </div>
                <div className="info-item">
                  <span className="label">Version</span>
                  <span className="value">{mapping.mappingMetadata?.version || 1}</span>
                </div>
              </div>

              <div className="mapping-fields">
                <h4>Custom Fields</h4>
                {mapping.customFields?.length === 0 ? (
                  <p className="no-fields">No custom fields in this mapping</p>
                ) : (
                  <div className="fields-grid">
                    {mapping.customFields?.map((field, idx) => (
                      <div key={idx} className="field-tag">
                        {field.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="mapping-actions">
                <button
                  className="btn-export"
                  onClick={() => handleExport(mapping._id)}
                >
                  <Download size={18} />
                  Export
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default FieldMappings;
